// @ts-nocheck
import * as Types from '@instamenu/data-access';

import gql from 'graphql-tag';
import * as Urql from 'urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type CreateSetupIntentMutationVariables = Types.Exact<{ [key: string]: never; }>;


export type CreateSetupIntentMutation = { __typename?: 'Mutation', createSetupIntent?: { __typename?: 'CreateSetupIntentMutationPayload', clientSecret: string } | null };


export const CreateSetupIntentDocument = gql`
    mutation createSetupIntent {
  createSetupIntent(input: {}) {
    clientSecret
  }
}
    `;

export function useCreateSetupIntentMutation() {
  return Urql.useMutation<CreateSetupIntentMutation, CreateSetupIntentMutationVariables>(CreateSetupIntentDocument);
};